export const BLOCK = {
    INFO: 'info',
    HALF: 'half',
    COLUMN: 'column',
    PHOTO: 'photo',
    MEDIA: 'media',
    MAIN: 'main',
    LINK: 'link',
    PRICE: 'price',
    CENTER: 'center',
    CONTACT: 'contact',
    ICON: 'icon',
    BUTTONS: 'buttons',
    START: 'start',
    TOP: 'top',
};
